import React from "react";
import { Icon } from "@iconify/react";
import MenuModal from "./Submenu/MenuModal";

const Badge = ({ icon, text }) => (
  <div
    style={{
      backgroundColor: "#1f2937",
      border: "1px solid #374151",
      color: "#e5e7eb",
      padding: "12px 14px",
      borderRadius: 8,
      display: "flex",
      alignItems: "center",
      gap: 8,
    }}
  >
    <Icon
      icon={icon}
      width="18"
      height="18"
      style={{ color: "var(--primaryColor)" }}
    />
    <span>{text}</span>
  </div>
);

const PromotionDetail = ({
  promotion,
  onBack,
  getImg,
  makeSvgPlaceholder,
  depositText,
  bonusText,
  turnoverText,
  receiveText,
}) => {
  const [openMenu, setOpenMenu] = React.useState(false);
  const handleBack = () => onBack?.();

  return (
    <div style={{ padding: 16, color: "#fff", margin: 24, borderRadius: 8 }}>
      <div style={{ marginBottom: 20 }}>
        <button
          onClick={handleBack}
          style={{
            background: "var(--primaryColor)",
            border: "1px solid var(--primaryColor)",
            borderRadius: 8,
            padding: "12px 20px",
            color: "#fff",
            fontSize: 14,
            fontWeight: 500,
            cursor: "pointer",
            transition: "all .3s ease",
            display: "flex",
            alignItems: "center",
            gap: 8,
            marginBottom: 20,
            boxShadow:
              "0 4px 12px color-mix(in srgb, var(--primaryColor) 30%, transparent)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow =
              "0 6px 16px color-mix(in srgb, var(--primaryColor) 45%, transparent)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow =
              "0 4px 12px color-mix(in srgb, var(--primaryColor) 30%, transparent)";
          }}
        >
          <Icon icon="mdi:arrow-left" width="16" height="16" />{" "}
          กลับไปโปรโมชั่นทั้งหมด
        </button>
      </div>
      <div
        style={{
          backgroundColor: "#2d2d2d",
          borderRadius: 12,
          overflow: "hidden",
          border: "1px solid #404040",
        }}
      >
        <div style={{ padding: 30 }}>
          {/* Image (left) | 2x2 badges (right) */}
          <div
            className="promo-detail-row"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 16,
              alignItems: "start",
              marginBottom: 24,
            }}
          >
            {/* LEFT: IMAGE */}
            <div
              style={{
                backgroundColor: "#111827",
                borderRadius: 8,
                border: "1px solid #374151",
                overflow: "hidden",
              }}
            >
              <img
                src={getImg(promotion, 1200, 800)}
                alt={`${promotion.Detail} - full`}
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "70vh",
                  objectFit: "contain",
                  display: "block",
                  backgroundColor: "#111827",
                }}
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = makeSvgPlaceholder(1200, 800);
                }}
              />
            </div>

            {/* RIGHT: BADGES + HOW-TO */}
            <div className="promo-right" style={{ display: "grid", gap: 12 }}>
              <h1
                style={{
                  color: "var(--primaryColor)",
                  fontSize: 28,
                  marginBottom: 20,
                  lineHeight: 1.4,
                }}
              >
                {promotion.Detail}
              </h1>
              <div
                className="promo-badges-grid"
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: 12,
                }}
              >
                {depositText(promotion) && (
                  <Badge icon="mdi:cash-plus" text={depositText(promotion)} />
                )}
                {bonusText(promotion) && (
                  <Badge icon="mdi:gift-outline" text={bonusText(promotion)} />
                )}
                {turnoverText(promotion) && (
                  <Badge icon="mdi:sync" text={turnoverText(promotion)} />
                )}
                {turnoverText(promotion) && (
                  <Badge icon="mdi:sync" text={receiveText(promotion)} />
                )}
                {promotion?.maxWithdraw > 0 && (
                  <Badge
                    icon="mdi:bank"
                    text={`ถอนได้สูงสุด ${promotion.maxWithdraw}`}
                  />
                )}
              </div>

              {/* Instructions moved under promo detail */}
              <div
                style={{
                  padding: 20,
                  backgroundColor: "#1f2937",
                  borderRadius: 8,
                  border: "1px solid #374151",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 12,
                    marginBottom: 12,
                  }}
                >
                  <h3
                    style={{
                      color: "var(--primaryColor)",
                      fontSize: 18,
                      margin: 0,
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Icon icon="mdi:information" width="20" height="20" />{" "}
                    วิธีการรับโปรโมชั่น
                  </h3>
                </div>

                <ol
                  style={{
                    color: "#d1d5db",
                    fontSize: 14,
                    lineHeight: 1.6,
                    paddingLeft: 20,
                    textAlign: "left",
                  }}
                >
                  <li>เข้าสู่ระบบบัญชีของคุณ</li>
                  <li>กดเลือกโปรโมชั่นที่เมนูตั้งค่าโปรโมชั่น</li>
                  <li>ทำการฝากเงินตามยอดที่กำหนดในแต่ละโปรโมชั่น</li>
                  <li>โบนัสจะเข้าอัตโนมัติ</li>
                </ol>
              </div>
              <button
                onClick={() => setOpenMenu(true)}
                style={{
                  background: "var(--primaryColor)",
                  border: "1px solid var(--primaryColor)",
                  borderRadius: 6,
                  padding: "8px 12px",
                  color: "#fff",
                  fontSize: 16,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                เลือกรับโปรโมชั่น
              </button>
            </div>
          </div>
        </div>
      </div>

      {openMenu && (
        <MenuModal onClose={() => setOpenMenu(false)} initialTab="autoPromo" />
      )}

      <style>{`@media (max-width:768px){h1{font-size:22px!important}h3{font-size:16px!important}.promo-detail-row{grid-template-columns:1fr!important}.promo-badges-grid{grid-template-columns:1fr!important}}`}</style>
    </div>
  );
};

export default PromotionDetail;
